import { Box, styled } from "@mui/material";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import AppFooter from "../_components/footer/app.footer";
import { AppToolbar } from "../_components/toolbar/app.toolbar";

const useStyles = {

    appScreen: {
        display: 'flex',
        backgroundColor: "#e6e6e6",
        height: "100%"
    },
    main: {
        marginTop: "40px"
    },
    root: {

    },
    mainBackground: {},
    stickToBottom: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        borderTop: '1px solid #e6e6e6',
        zIndex: 9999
    },
    toolbar: {},
};

const Main = styled('main')(({ theme }) => ({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100dvh',

    width: '100%',
    maxWidth: '100%',

    paddingTop: theme.spacing(10),

    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
}));


export function AppScreen() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    }

    return (
        <div style={useStyles.appScreen} id="app-screen">

            <AppToolbar toggleSidebar={toggleSidebar} isOpen={isOpen}></AppToolbar>

            <Main>
                <Box
                    sx={{
                        flex: 1,
                        overflow: 'auto',
                        p: { xs: 1.5, md: 4 }
                    }}
                >
                    <Outlet />
                </Box>

                <AppFooter />
            </Main>

        </div >
    );
}